import { GalleryImage, GalleryCategory } from '../../../mocks/galleryData';

interface GalleryGridProps {
  images: GalleryImage[];
  activeCategory: GalleryCategory;
  onImageClick: (index: number) => void;
}

export default function GalleryGrid({ images, onImageClick }: GalleryGridProps) {
  if (images.length === 0) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 flex flex-col items-center justify-center text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-stone-100 mb-5">
          <i className="ri-image-line text-2xl text-stone-400"></i>
        </div>
        <h3 className="text-lg font-semibold text-stone-700 mb-2">No images yet</h3>
        <p className="text-stone-400 text-sm max-w-xs">
          Photos for this category are coming soon. Check back later!
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {images.map((img, idx) => (
          <div
            key={img.id}
            className="relative h-64 rounded-xl overflow-hidden cursor-pointer group"
            onClick={() => onImageClick(idx)}
          >
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/20 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <i className="ri-zoom-in-line text-base"></i>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
